<geaui-page-header pageTitle="Pipe Sizes and Schedules" [hasBackArrow]="false" [withSidebar]="true">
  <div class="UnitsSelector">
    Units:
    <mat-radio-group [(ngModel)]="isUsUnits">
      <mat-radio-button [value]="true">US</mat-radio-button>
      <mat-radio-button [value]="false">SI</mat-radio-button>
    </mat-radio-group>
  </div>
</geaui-page-header>

<div *ngIf="!isLoaded" class="Content">
  <h3 class="Heading">Loading...</h3>
</div>
<div *ngIf="isLoaded" class="Content">

  <table>
    <thead>
      <tr>
        <th colspan="2">Size</th>
        <th *ngFor="let schedule of viewModel.PipeSizes.Value[0].Schedules">{{ schedule.Name }}</th>
      </tr>
      <tr>
        <th>Nominal</th>
        <th>OD</th>
        <th *ngFor="let schedule of viewModel.PipeSizes.Value[0].Schedules">ID / Wall</th>
      </tr>
      <tr style="font-style: italic; background-color: #f5f5f5;">
        <td>{{ getUnitText(MeasurementContext.PipeSize) }}</td>
        <td>{{ getUnitText(MeasurementContext.InchOrMm) }}</td>
        <td *ngFor="let schedule of viewModel.PipeSizes.Value[0].Schedules">{{ getUnitText(MeasurementContext.InchOrMm) }}</td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let size of viewModel.PipeSizes.Value">
        <td>{{ formatUnits(size.NominalSize, MeasurementContext.PipeSize, 3) }}</td>
        <td>{{ formatUnits(size.OuterDiameter, MeasurementContext.InchOrMm, 3) }}</td>
        <td *ngFor="let schedule of size.Schedules">{{ formatUnits(schedule.InnerDiameter, MeasurementContext.InchOrMm, 3) ? formatUnits(schedule.InnerDiameter, MeasurementContext.InchOrMm, 3) + " / " + formatUnits(schedule.WallThickness, MeasurementContext.InchOrMm, 3) : "" }}</td>
      </tr>
    </tbody>
  </table>

</div>